// Formattazione italiana per date e valori economici.

export function formatDate(value) {
  if (!value) return "—";
  if (typeof value === "string") {
    const t = value.trim();
    let m;
    if ((m = t.match(/^(\d{4})-(\d{2})-(\d{2})$/))) return `${m[3]}/${m[2]}/${m[1]}`;
    if ((m = t.match(/^(\d{1,2})[/.\-](\d{1,2})[/.\-](\d{4})$/))) return `${m[1].padStart(2, "0")}/${m[2].padStart(2, "0")}/${m[3]}`;
    if ((m = t.match(/^(\d{2})(\d{2})(\d{4})$/))) return `${m[1]}/${m[2]}/${m[3]}`;
  }
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const gg = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const aaaa = d.getFullYear();
  return `${gg}/${mm}/${aaaa}`;
}

export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(value)} ${hh}:${min}`;
}

export function formatDateTimeSec(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  const sec = String(d.getSeconds()).padStart(2, "0");
  return `${formatDate(value)} ${hh}:${min}:${sec}`;
}

// Formatta live un input importo in stile italiano: migliaia con punto, decimali con virgola.
export function formatItInput(raw) {
  if (raw == null) return "";
  let s = String(raw).replace(/[^\d,]/g, "");
  const firstComma = s.indexOf(",");
  let intPart = firstComma === -1 ? s : s.slice(0, firstComma);
  let decPart = firstComma === -1 ? null : s.slice(firstComma + 1).replace(/,/g, "").slice(0, 2);
  intPart = intPart.replace(/^0+(?=\d)/, "");
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  if (intPart === "") intPart = decPart !== null ? "0" : "";
  return decPart !== null ? `${intPart},${decPart}` : intPart;
}

// Converte una stringa importo italiana (4.450,00) in numero JS.
export function parseItNumber(raw) {
  if (raw == null || raw === "") return 0;
  const s = String(raw).replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

// Converte un numero in stringa italiana per popolare un input in modifica.
export function numberToItInput(value) {
  if (value === "" || value == null) return "";
  const n = Number(value);
  if (isNaN(n)) return "";
  const [intPart, decPart] = n.toFixed(2).split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${grouped},${decPart}`;
}

// Converte un valore importo in stringa di display italiana per input live.
export function toItInputDisplay(v) {
  if (v === "" || v == null) return "";
  if (typeof v === "number") return numberToItInput(v);
  return formatItInput(String(v));
}

// Numero in formato italiano senza simbolo: migliaia con ".", decimali con "," (2 cifre fisse).
export function formatNumIt(value) {
  const n = Number(value || 0);
  const [intPart, decPart] = Math.abs(n).toFixed(2).split(".");
  const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${n < 0 ? "-" : ""}${grouped},${decPart}`;
}

export function formatEuro(value) {
  return `${formatNumIt(value)} €`;
}
